import React, { useReducer, createContext } from 'react';

export const DetTunersContext = createContext();

const initialState = {
  tuners: [],
  detectors: [],
  boards: [],
};

function reducer(state, action) {
  switch (action.type) {    
    case 'RESET': {
      return initialState;
    }
    case 'SETTUNERS': {
      if (action.payload === undefined)
        return state;
      return {
        ...state,
        tuners: action.payload
      };
    }
    case 'UPDATETUNER': {
      if (action.payload === undefined)
        return state;
      const newTuner = action.payload;
      let tuners = state.tuners;
      var oldInd = tuners.findIndex(d => d.TunerId == newTuner.TunerId);
      if (oldInd !== -1) {
        tuners[oldInd] = newTuner;
      }
      else {
        tuners = [...tuners, newTuner];
      }
      return {
        ...state,
        tuners: tuners
      };
    }
    case 'DELETETUNER': {
      if (action.payload === undefined)
        return state;
      const tuners = state.tuners.filter(p => p.TunerId != action.payload);
      return {
        ...state,
        tuners: tuners
      };
    }
    case 'SETDETECTORS': {
      if (action.payload === undefined)
        return state;
      return {
        ...state,
        detectors: action.payload
      };
    }
    case 'UPDATEDETECTOR': {
      if (action.payload === undefined)
        return state;
      const newDet = action.payload;
      let detectors = state.detectors;
      var oldDetInd = detectors.findIndex(d => d.ID == newDet.ID);
      if (oldDetInd !== -1) {
        detectors[oldDetInd] = newDet;
      }
      else {
        detectors = [...detectors, newDet];
      }

      return {
        ...state,
        detectors: detectors
      };
    } 
    case 'DELETEDETECTOR': {
      if (action.payload === undefined)
        return state;
      const detectors = state.detectors.filter(p => p.ID != action.payload);
      return {
        ...state,
        detectors: detectors
      };
    }

    case 'SETBOARDS': {
      if (action.payload === undefined)
        return state;
      return {
        ...state,
        boards: action.payload
      };
    }
    case 'UPDATEBOARD': {
      if (action.payload === undefined)
        return state;
      const newData = action.payload;
      let boards = state.boards;
      var oldBoardInd = boards.findIndex(d => d.ID == newData.ID);
      if (oldBoardInd !== -1) {
        boards[oldBoardInd] = {...newData, BoardType: null, BoardDesignation: null};
      }
      else {
        if (!boards.find(b => b.ID == newData.ParentID)) {
          boards = [...boards, {ID: newData.ParentID, BoardType: newData.BoardType, BoardDesignation: newData.BoardDesignation}];
        }
        boards = [...boards, {...newData, BoardType: null, BoardDesignation: null}];
      }

      return {
        ...state,
        boards: boards
      };
    } 
    case 'DELETEBOARD': {
      if (action.payload === undefined)
        return state;
      let boards = state.boards;
      var oldBoard = boards.find(d => d.ID == action.payload);
      boards = boards.filter(p => p.ID != oldBoard.ID);
      if (!boards.find(b => b.ParentID == oldBoard.ParentID)) {
        boards = boards.filter(p => p.ID != oldBoard.ParentID)
      }
      return {
        ...state,
        boards: boards
      };
    }

    default:
      throw new Error();
  }
}

export const DetTunersContextProvider = props => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { children } = props;

  return (
    <DetTunersContext.Provider value={[state, dispatch]}>
      {children}
    </DetTunersContext.Provider>
  );
};